import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { extend, QueryProvider } from '@thd-nucleus/data-sources';
import { MiniPIPBase } from './MiniPIPBase';
import { MiniPIPFull } from './MiniPIPFull';
import { ProductOverview } from './ProductOverview';
import { ProductSpecs } from './ProductSpecs';
import { ProductReviews } from './ProductReviews';
import { AddToContext } from '../../AddToContext';
import { SCREENS } from '../../AddToConstants';

export const HoistedFragment = ({ children }) => {
  return children;
};

HoistedFragment.dataModel = extend(MiniPIPBase, ProductOverview, ProductSpecs, ProductReviews, MiniPIPFull);

export const MiniPip = ({
  itemId, updateList, isSearchResults, isDisplayOnly, hideSalientPoints, isIntent = false, handleResolveIntent,
}) => {
  const { screen, storeId, membershipInformation } = useContext(AddToContext);
  const {
    MINI_PIP_BASE, MINI_PIP_PRODUCT_OVERVIEW, MINI_PIP_PRODUCT_SPECS, MINI_PIP_PRODUCT_REVIEWS, MINI_PIP_FULL
  } = SCREENS;
  return (
    <QueryProvider
      cacheKey="MiniPIP"
      dataSource="catalog"
      defaultVariables={{
        storeId,
        skipInstallServices: true,
        loyaltyMembershipInput: membershipInformation?.data?.loyaltyMembership || null
      }}
    >
      <HoistedFragment>
        {screen === MINI_PIP_BASE && (
          <MiniPIPBase
            itemId={itemId}
            updateList={updateList}
            isSearchResults={isSearchResults}
            isIntent={isIntent}
            handleResolveIntent={handleResolveIntent}
            isDisplayOnly={isDisplayOnly}
            hideSalientPoints={hideSalientPoints}
          />
        )}
        {screen === MINI_PIP_PRODUCT_OVERVIEW && (
          <ProductOverview
            itemId={itemId}
            updateList={updateList}
            isDisplayOnly={isDisplayOnly}
            handleResolveIntent={handleResolveIntent}
            isIntent={isIntent}
          />
        )}
        {screen === MINI_PIP_PRODUCT_SPECS && (
          <ProductSpecs
            itemId={itemId}
            updateList={updateList}
            isDisplayOnly={isDisplayOnly}
            handleResolveIntent={handleResolveIntent}
            isIntent={isIntent}
          />
        )}
        {screen === MINI_PIP_PRODUCT_REVIEWS && (
          <ProductReviews
            itemId={itemId}
            updateList={updateList}
            isDisplayOnly={isDisplayOnly}
            handleResolveIntent={handleResolveIntent}
            isIntent={isIntent}
          />
        )}
        {screen === MINI_PIP_FULL && (
          <MiniPIPFull itemId={itemId} isSearchResults={isSearchResults} />
        )}
      </HoistedFragment>
    </QueryProvider>
  );
};

MiniPip.displayName = 'MiniPip';

MiniPip.propTypes = {
  itemId: PropTypes.string.isRequired,
  updateList: PropTypes.func,
  isSearchResults: PropTypes.bool,
  isDisplayOnly: PropTypes.bool,
  hideSalientPoints: PropTypes.bool,
  handleResolveIntent: PropTypes.func,
  isIntent: PropTypes.bool
};

MiniPip.defaultProps = {
  updateList: () => {},
  isSearchResults: false,
  isDisplayOnly: false,
  hideSalientPoints: false,
  handleResolveIntent: null,
  isIntent: false,
};
